// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3GEZ1","content":"RecentSearches_content__2BkLN"};